if (window.matchMedia('(max-width: 749px)').matches) {
  function initZoom() {
    const selector = '[id^="GalleryViewer"] .media img, .product__modal-opener--image img';

    document.querySelectorAll(selector).forEach((img) => {
      if (img.dataset.zoomInit && img.complete) return;
      img.dataset.zoomInit = true;

      const wrapper = img.closest('.media, .product__modal-opener--image, .product__media');
      if (!wrapper) return;

      const scale = 2;
      let isZoomed = false;
      let isDragging = false;
      let startX = 0;
      let startY = 0;
      let lastX = 0;
      let lastY = 0;
      let translateX = 0;
      let translateY = 0;
      let hasMoved = false;

      wrapper.style.overflow = 'hidden';
      wrapper.style.touchAction = 'pan-y';

      img.style.transformOrigin = 'center center';
      img.style.transition = 'transform 0.2s ease';
      img.style.willChange = 'transform';
      img.style.touchAction = 'pan-y';

      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      function applyTransform() {
        img.style.transform = `scale(${scale}) translate(${translateX / scale}px, ${translateY / scale}px)`;
      }

      function zoomIn() {
        isZoomed = true;
        isDragging = false;
        hasMoved = false;
        translateX = 0;
        translateY = 0;

        wrapper.classList.add('ambar-mobile-zoom-active');
        wrapper.style.touchAction = 'none';
        img.style.touchAction = 'none';

        img.style.transition = 'transform 0.2s ease';
        applyTransform();
      }

      function zoomOut() {
        isZoomed = false;
        isDragging = false;
        hasMoved = false;
        translateX = 0;
        translateY = 0;

        wrapper.classList.remove('ambar-mobile-zoom-active');
        wrapper.style.touchAction = 'pan-y';
        img.style.touchAction = 'pan-y';

        img.style.transition = 'transform 0.2s ease';
        img.style.transform = 'scale(1) translate(0, 0)';
      }

      wrapper.addEventListener(
        'click',
        function (e) {
          if (isZoomed || hasMoved) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        },
        true
      );

      wrapper.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || e.touches.length !== 1) return;

          startX = lastX = e.touches[0].clientX;
          startY = lastY = e.touches[0].clientY;
          hasMoved = false;

          if (isZoomed) {
            isDragging = true;
            img.style.transition = 'none';

            e.preventDefault();
            e.stopPropagation();
          }
        },
        { passive: false, capture: true }
      );

      wrapper.addEventListener(
        'touchmove',
        function (e) {
          if (!isZoomed || !isDragging || !e.touches || e.touches.length !== 1) return;

          e.preventDefault();
          e.stopPropagation();

          const currentX = e.touches[0].clientX;
          const currentY = e.touches[0].clientY;

          const dx = currentX - lastX;
          const dy = currentY - lastY;

          if (Math.abs(currentX - startX) > 3 || Math.abs(currentY - startY) > 3) {
            hasMoved = true;
          }

          lastX = currentX;
          lastY = currentY;

          const maxX = (wrapper.offsetWidth * (scale - 1)) / 2;
          const maxY = (wrapper.offsetHeight * (scale - 1)) / 2;

          translateX = clamp(translateX + dx, -maxX, maxX);
          translateY = clamp(translateY + dy, -maxY, maxY);

          applyTransform();
        },
        { passive: false, capture: true }
      );

      wrapper.addEventListener(
        'touchend',
        function (e) {
          if (!e.changedTouches || !e.changedTouches.length) return;

          const endTouch = e.changedTouches[0];

          const movedX = Math.abs(endTouch.clientX - startX);
          const movedY = Math.abs(endTouch.clientY - startY);
          const wasTap = movedX < 8 && movedY < 8;

          if (isZoomed) {
            e.preventDefault();
            e.stopPropagation();
          }

          if (wasTap) {
            if (isZoomed) {
              zoomOut();
            } else {
              zoomIn();
            }
          }

          isDragging = false;
        },
        { passive: false, capture: true }
      );

      img.addEventListener('load', function () {
        img.dataset.zoomInit = '';
        setTimeout(initZoom, 50);
      });
    });
  }

  window.addEventListener('load', initZoom);
  document.addEventListener('DOMContentLoaded', initZoom);
  document.addEventListener('shopify:section:load', initZoom);
  document.addEventListener('variant:change', initZoom);
  document.addEventListener('media-gallery:change', initZoom);

  const galleryObserver = new MutationObserver(() => {
    setTimeout(initZoom, 50);
  });

  galleryObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}